<template>
  <div class="container">
    <div :class="{content: true,empty: list.length === 0}">
      <div :class="['clueList','myClue','top','nearTop']">
        <div class="nav">
          <li v-for="(f, i) in filters" :key="i">
            <div class="status">
              <label>{{f.title}}</label>
              <span :class="{active: s.selected}" v-for="(s, si) in f.list" @click="choseStatus(s, f)" :key="si">{{s.title}}</span>
            </div>
          </li>
          <div class="nav pr0">
            <li class="upload creat" v-if="showCreate">
              <button @click="goCreate()">{{`新建${$_syscfg.publish}`}}</button>
            </li>
          </div>
        </div>
      </div>
      <!-- 报道审核、我的报道样式 -->
      <div :class="['clueList','on',list.length === 0 ? 'empty': '']">
        <div class="list">
          <empty :mTop="30" v-if="list && list.length === 0 && !waiting" :msg="`暂无${$_syscfg.publish}数据`" />
          <skeleton v-show="waiting"></skeleton>
          <ul v-show="!waiting" v-for="(item, index) in list" :key="index">
            <!-- <label @click="selectOne(item)"><img :src="item.selected ? icons.checkerOn : icons.checker" class="checker" alt="checker"></label> -->
            <img v-if="item.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
            <div class="thumImg" @click="viewMedia(item)">
              <p class="tags" v-if="item.has_avid_icon || item.has_kankan_icon || item.has_iditor_icon">
                <img v-if="item.has_avid_icon" src="@assets/img/index/tv.svg" alt="tv">
                <img v-if="item.has_kankan_icon" src="@assets/img/index/kankan.svg" alt="kankan">
                <img v-if="item.has_iditor_icon" src="@assets/img/index/dxgg.svg" alt="dxgg">
              </p>
              <img @error="imgError(item)" class="cover" :src="item.img_url || defaultImg" alt="img">
              <img v-if="item.play_icon - 0 === 1 && item.img_url" class="play" src="@assets/img/index/play.svg" alt="play">
            </div>
            <dl>
              <a @click="handleGo(item)">
                <h4 :class="{news: item.is_new == 1}">
                  <span :class="{statusTag: true, greenTag: item.status == 0, redTag: item.status == 3, yellowTag: item.status == 1}"
                    v-if="item.status_name && item.status != 2">{{item.status_name}}</span>
                  <span class="title" :title="item.title">
                    {{item.title}}
                  </span>
                  <img src="@assets/img/common/tips.svg" alt="change" v-if="item.has_change - 0 === 1">
                  <img src="@assets/img/common/new.svg" alt="new" v-if="item.is_new - 0 === 1">
                  <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="item.has_img - 0 === 1">
                  <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="item.has_video - 0 === 1">
                  <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="item.has_sound - 0 === 1">
                  <!-- todo 22 -->
                  <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="item.has_audit&&item.has_audit==2" src="@assets/img/common/verify-fail.svg">
                </h4>
                <li>{{item.content}}</li>
              </a>
              <li class="smal">
                <span>{{item.user_name}}</span>
                <span>{{item.add_time}}</span>
                <span class="publish" v-for="(c,i) in item.column" :key="i">
                  {{`${c.ftitle ? c.ftitle : ""} ${c.stitle ? c.stitle : ""  } ${c.ttitle ? c.ttitle : ""}`}}
                </span>
              </li>
            </dl>
            <!-- 我的发布 -->
            <div class="doubleCreat">
              <div class="line">
                <button class="success" v-if="item.has_release" @click="publish(item.publish_id)">发布</button>
                <button v-if="item.has_verify" class="success" @click="toCheck(item.publish_id)">送审</button>
                <button v-if="item.has_edit" @click="goEdit(item.publish_id)">编辑</button>
                <button class="success" v-if="item.has_copy" @click="copyReport(item.publish_id)">复制</button>
                <button v-if="item.has_new_media" @click="pushMedia(item)">推新发布</button>
                <button v-if="item.has_update" @click="goEdit(item.publish_id)">更新</button>
                <button v-if="item.has_del" @click="deleteItem(item)">删除</button>
              </div>
            </div>
          </ul>
        </div>
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
    <pushBox ref="pushBox" />
    <checkers ref="checkers" />
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import pages from "@components/pages";
import pushBox from "@components/pushBox";
import checkers from "@components/checkers";
import empty from "@components/empty";
import skeleton from "@components/skeleton";
import Vue from "vue";

export default {
  components: { pages, pushBox, checkers, empty, skeleton },
  data() {
    return {
      waiting: true,
      isXnew: this.$store.state.isXnew,
      list: [],
      defaultImg: require("@assets/img/common/default.png"),
      page: {
        pageCount: 0,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      allSelected: false,
      backShow: false,
      pushBox: false,
      icons: {
        checker: require("@assets/img/interview/checker.svg"),
        checkerOn: require("@assets/img/interview/checkerOn.svg")
      },
      filters: [],
      filterOptions: {},
      searchOptions: {},
      showCreate: false
    };
  },
  methods: {
    imgError(i) {
      // 图片加载状态
      this.$set(i, "img_url", this.defaultImg);
    },
    async pushMedia(item) {
      console.log(item)
      const type = await this.$MediaPlatform('push');
      if (!type) return;
      console.log(type)
      let info = {
          platforms: type,
          submit_type: 0,
          subject_type: 2,
          subject_id: item.publish_id
      };

      common
      .myFetch(apis.newMediaPlatformCreate, info)
      .then(r => {
          if (r) {
              console.log(r)
              common.jump(`/createMediaPublish?d=${r.report_id}`, true);
          }
      });
      // common.jump(`/createMediaPublish?d=${type}`, true);
    },
    async copyReport(id) {
      // 复制报道
      const type = await this.$pageType("publish");
      if (!type) return;

      const info = {
        id: id,
        type: type
      };

      const newWindow = window.open();

      common.myFetch(apis.Publish_copy, info).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editPublish?t=${type}&d=${r.id}`;

          // common.jump(`/editPublish?d=${r.id}`, true)
        }
      });
    },
    goViewLink(i) {
      if (i.url) {
        window.open(i.url);
      }
    },
    async viewMedia(item) {
      let list = await common.myFetch(apis.File_status, {
        subject_id: item.publish_id,
        subject_type: 2
      })
      common.openMaterialBox(list, null, false);
    },
    //送审
    async toCheck(id) {
      const info = {
        id: id
      };

      common.myFetch(apis.publishAddverify, info).then(r => {
        if (r) {
          this.$toast(r);
          this.getList();
        }
      });
    },
    async publish(id) {
      // 发布
      const info = {
        id: id
      };
      common.myFetch(apis.Rpb_release, info).then(res => {
        if (res) {
          this.$toast(`${res.msg_one}，${res.msg_two}`);

          this.getList();
        }
      });
    },
    async deleteItem(i) {
      let confirm = {};

      if(i.status == 0){
        confirm = await this.$confirmTitle({
          title: `确定删除该发布？`,
          msg: "同时删除关联素材，释放草稿空间",
          status: true,
          isCg: i.status == 0 ? true : false
        });
      }else{
        let msg = `删除该发布？`;

        confirm.status = await this.$confirm(msg);
        confirm.isSelected = 0;
      }

      if (!confirm.status) return;

      const info = {
        id: i.publish_id,
        del_source: confirm.isSelected ? 1 : 0
      };

      common.myFetch(apis.deletePublish, info).then(r => {
        if (r) {
          this.$toast(r);
          this.getList();
        }
      });
    },
    selectAll() {
      // 全选／反选
      const pushlist = this.list.filter(l => {
        if (l.has_push) {
          return l;
        }
      });

      this.allSelected = !this.allSelected;

      pushlist.forEach(i => {
        this.$set(i, "selected", this.allSelected);
      });

      if (pushlist.length !== this.page.pageSize) {
        let msg = "已选中有发送权限的条目";
        if (pushlist.length === 0) {
          msg = "暂无可发送的条目";
        }

        this.$toast(msg);
        this.allSelected = false;
      }
    },
    selectOne(i) {
      // 选择／反选
      if (!i.has_push) {
        this.$toast("无发送权限，无法选中");
        return;
      }

      this.$set(i, "selected", !i.selected);

      this.$nextTick(() => {
        if (!i.selected) {
          this.allSelected = false;
        }
      });
    },
    getViewNum(info) {
      // 异步读取浏览数据并赋值
      common.myFetch(apis.Rpt_viewnum, info).then(r => {
        if (r) {
          const viewData = r.list;

          this.list.forEach(i => {
            if (viewData[i.idstring]) {
              this.$set(i, "view_num", viewData[i.idstring].count);
              this.$set(i, "link", viewData[i.idstring].url);
            }
          });
        }
      });
    },
    getList(keyWord) {
      this.waiting = true;
      const id = this.$route.params.id;
      let info = {
        idstring: id,
        search_option: "",
        key_words: "",
        status: "",
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      };

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions);

      common
        .myFetch(apis.mypublish, info)
        // common.myFetch(apis.myreport, info)
        .then(res => {
          this.allSelected = false;
          this.list = res.list;
          // const info = {
          //   time_start: res.time_start,
          //   time_end: res.time_end
          // }
          // this.getViewNum(info)
          this.filters = res.params.list_search;
          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
          this.showCreate = res.has_add_role;
          // this.showCreate = true

          this.$nextTick(() => {
            this.waiting = false;
          })
        });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    choseStatus(i, l) {
      // 选择筛选项
      if (i.selected) return;

      this.page.pageIndex = 1;

      l.list.forEach(li => {
        li["selected"] = false;
      });

      this.$set(i, "selected", true);
      this.filterOptions[l.key] = i.key;
      this.getList();
    },
    async goCreate() {
      const type = await this.$pageType("publish");
      if (!type) return;

      common.jump(`/createPublish?t=${type}`, true);
    },
    handleGo(i) {
      const s = i.status;
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);

      if (s == 0 || s == 3) {
        this.goEdit(i.publish_id);
      } else if (s == 1 || s == 2) {
        this.goDetail(i.publish_id);
      }
    },
    async goEdit(id) {
      const newWindow = window.open();
      common.checkPageStatus(id, 2).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editPublish?d=${id}`;
        } else {
          newWindow.close();
        }
      });
    },
    goDetail(id) {
      common.jump(`/publishDetail?d=${id}`, true);
    },
    push(id) {
      this.$refs.pushBox.open(id);
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.getList('noKeyWord');
  }
};
</script>

<style src="@assets/css/publish/myPublish.less" lang="less" scoped>
</style>
